import { render } from "./independent.vue?vue&type=template&id=f18e98e8&scoped=true"
import script from "./independent.vue?vue&type=script&lang=js"
export * from "./independent.vue?vue&type=script&lang=js"

import "./independent.vue?vue&type=style&index=0&id=f18e98e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18e98e8"]])

export default __exports__